import * as React from 'react';
import { AuthManager } from './containers/AuthManager';

// render react DOM
const App: React.FC = () => <AuthManager />;

export default App;
